var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-2l2-2v4H3zm4 0v-6l2-2v8H7zm4 0v-8l2 2.025V21h-2zm4 0v-5.975l2-2V21h-2zm4 0V11l2-2v12h-2zM3 15.825V13l7-7 4 4 7-7v2.825l-7 7-4-4-7 7z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMyAyMVYxOUw1IDE3VjIxSDNaTTcgMjFWMTVMOSAxM1YyMUg3Wk0xMSAyMVYxM0wxMyAxNS4wMjVWMjFIMTFaTTE1IDIxVjE1LjAyNUwxNyAxMy4wMjVWMjFIMTVaTTE5IDIxVjExTDIxIDlWMjFIMTlaTTMgMTUuODI1VjEzTDEwIDZMMTQgMTBMMjEgM1Y1LjgyNUwxNCAxMi44MjVMMTAgOC44MjVMMyAxNS44MjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+";
export { ForwardRef as ReactComponent };